// User scroll detection
let isUserScrolling = false
let userScrollTimeout = null

function resetUserScrollFlag() {
  clearTimeout(userScrollTimeout)
  userScrollTimeout = setTimeout(() => {
    isUserScrolling = false
  }, 300)
}

// User-initiated scroll listeners
window.addEventListener('wheel', () => {
  isUserScrolling = true
  resetUserScrollFlag()
})
window.addEventListener('touchmove', () => {
  isUserScrolling = true
  resetUserScrollFlag()
})
window.addEventListener('keydown', e => {
  if (['ArrowDown', 'ArrowUp', 'PageDown', 'PageUp', 'Home', 'End', 'Space'].includes(e.code)) {
    isUserScrolling = true
    resetUserScrollFlag()
  }
})
/**
 * Returns true if the user is currently scrolling or has recently scrolled.
 * The flag resets to false after 300ms of inactivity.
 * @returns {boolean}
 */
export function getIsUserScrolling() {
  return isUserScrolling
}
